import { defaultFill } from './utils/constants';
var muiChevronLeftBase = {
    paths: [
        {
            path: 'M5.20992366,11.7040359 L0.29389313,6.75336323 C0.187022901,6.64573991 0.111323155,6.52914798 0.0667938931,6.40358744 C0.022264631,6.27802691 0,6.14349776 0,6 C0,5.85650224 0.022264631,5.72197309 0.0667938931,5.59641256 C0.111323155,5.47085202 0.187022901,5.35426009 0.29389313,5.24663677 L5.20992366,0.295964126 C5.40585242,0.0986547085 5.65521628,0 5.95801527,0 C6.26081425,0 6.51017812,0.0986547085 6.70610687,0.295964126 C6.90203562,0.493273543 7,0.744394619 7,1.04932735 C7,1.35426009 6.90203562,1.60538117 6.70610687,1.80269058 L2.53816794,6 L6.70610687,10.1973094 C6.90203562,10.3946188 7,10.6457399 7,10.9506726 C7,11.2556054 6.90203562,11.5067265 6.70610687,11.7040359 C6.51017812,11.9013453 6.26081425,12 5.95801527,12 C5.65521628,12 5.40585242,11.9013453 5.20992366,11.7040359 Z',
            fill: defaultFill,
        },
    ],
    title: 'chevron left',
    width: 24,
    height: 24,
    rotate: 0,
    translate: [8, 6],
};
var muiChevronLeft = {
    base: muiChevronLeftBase,
};
export { muiChevronLeft };
//# sourceMappingURL=chevronLeft.js.map